export enum VideoEncodingStatus {
  READY = 0,
  PROCESSING = 1,
  FAILED = 2,
}
